import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8753f5ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-2" }

import IconBase from '@/components/Icons/IconBase.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'CircleButton',
  props: {
  name: {
    type: String,
    default: 'like'
  },
  iconWidth: {
    type: Number,
    default: 50
  },
  iconHeight: {
    type: Number,
    default: 50
  },
  viewBox: {
    type: String,
    default: '0 0 50 50'
  },
  bg: {
    type: String,
    default: 'gray'
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['btn', `bg-${props.bg}`])
  }, [
    (props.name !== 'empty')
      ? (_openBlock(), _createBlock(IconBase, {
          key: 0,
          name: props.name,
          "view-box": props.viewBox,
          width: props.iconWidth,
          height: props.iconHeight
        }, null, 8, ["name", "view-box", "width", "height"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})